import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'

interface FlashPackageSelectionEligibility {
  availableForPurchase: boolean
  isFlightsSelected: boolean
  mustBundleWithFlights: boolean
  hasCharterBundle: boolean
  isWeddingGiftRegistry: boolean
  walledGarden: boolean
}

/** The same pre-treatment commercial boundary is used for both assigned arms. */
export function isFlashPackageSelectionEligible(input: FlashPackageSelectionEligibility): boolean {
  return input.availableForPurchase &&
    !input.walledGarden &&
    !isAgentHubEnabled &&
    !input.isFlightsSelected &&
    !input.mustBundleWithFlights &&
    !input.hasCharterBundle &&
    !input.isWeddingGiftRegistry
}
